import axios from "axios";

export const controlSponsorReportApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND}api/control-sponsor-report`,
  headers: {
    "Content-Type": "application/json",
  },
});
